export const BILLABLES_OVERVIEW = "Sum of all billables grouped by status."

export const TOTAL_INFO = "Total value of all billables scheduled for this period based on the billing date.";

export const BILLING_HEALTH_INSIGHTS = "Quick overview of overdue billables, invoices, and upcoming dues to track collection health."

export const OVERDUE_BILLABLES = "Sum of Billables that were due but haven't been collected yet."
export const DELAYED_AMOUNT = "Billables past their billing date that are still not invoiced."
export const OVERDUE_AMOUNT = "Invoiced billables where payment is pending beyond the due date."

// Status card information descriptions
export const CONTRACTED_INFO = "Total billables planned for invoicing based on the billing date"
export const PENDING_INVOICE_INFO = "Billables whose billing date has arrived, yet to be invoiced by an Account Team."
export const BILLED_INFO = "Total amount invoiced to clients based on the invoice date."
export const COLLECTED_INFO = "Payments received from clients based on the collection date."
export const CANCELLED_INFO = "Cancelled billables within the billing date in the selected date range."